export const CREATE_NOTICE_SUCCESS="resource/CREATE_NOTICE_SUCCESS";
export const CREATE_NOTICE_FAILURE="resource/CREATE_NOTICE_FAILURE";
export const GET_NOTICE_LIST_SUCCESS="resource/GET_NOTICE_LIST_SUCCESS";
export const GET_NOTICE_LIST_FAILURE="resource/GET_NOTICE_LIST_FAILURE";
export const EDIT_NOTICE_SUCCESS="resource/EDIT_NOTICE_SUCCESS";
export const EDIT_NOTICE_FAILURE="resource/EDIT_NOTICE_FAILURE";
export const DELETE_NOTICE_SUCCESS="resource/DELETE_NOTICE_SUCCESS";
export const DELETE_NOTICE_FAILURE="resource/DELETE_NOTICE_FAILURE";
